import React, { useEffect, useState, useMemo } from "react";
import arrow_back_ios_new from "../../assets/Images/arrow_back_ios_new.png";
import "./SubscriptionPayment.css"; // Plan NameImport your CSS file for animations
import { useNavigate, useLocation } from "react-router-dom";
import showSubscriptionToast from "./SubscriptionToast";
import {
  useAsaSession,
  useAsaSessionPagesMutation,
  useIsLoading,
  useBackButton,
} from "../../services/AsaSessionServices";
import {
  useActiveSubscriptions,
  useSubscriptionsPlans,
  useRateOnUpgradePlan,
  useFintechLayouts,
  useBillingAddresses,
  useSubscriptionPaymentMutation,
  usePaymentMethods,
  useSubscriptionPaymentMethodUpdateMutation,
  useFintechSubscriptions,
  useSubscriptionReacivateMutation
} from "../../services/AsaApiServices";

import { useDispatch, useSelector } from "react-redux";
import {
  SessionState,
  setNewPaymentField,
  setPaymentCVV,
  setSelectedPaymentMethod,
  setSelectedBillingAddress,
} from "../../redux/sessionSlice";

import { BillingAddress, PaymentMethod, SubscriptionPlanData,SessionPage } from "../../types/types";
import ConfirmDialogCVV from "../../components/ConfirmDialogCVV";
import LoaderComponent from "../../components/LoaderComponent";
import PaymentMethodCard from "../../components/PaymentMethodCard";
import BillingAddressCard from "../../components/BillingAddressCard";
import Dropdown from "./DropDown";
import { useTranslation } from "react-i18next";
import {
  AnalyticsService,
  AnalyticsAction,
  AnalyticsFeature,
} from "../../services/AnalyticsService";

// this is first step of refactoring of Portfoliopilot page without touching logic



const SubscriptionPayment: React.FC = () => {
  const { t } = useTranslation();

  const { data: billingAddresses } = useBillingAddresses();

  const { data: paymentMethods } = usePaymentMethods();
  const layout = useFintechLayouts();
  const { data: session } = useAsaSession();

  //const sessionMutation=useAsaSessionPagesMutation()
  const { data: activesubscriptions } = useActiveSubscriptions();
  const subscriptionPaymentMutation = useSubscriptionPaymentMutation();
  const {data:fintechSubscriptions}=useFintechSubscriptions()
  const subscriptionPaymentMethodMutation = useSubscriptionPaymentMethodUpdateMutation();
  const subscriptionReacivateMutation= useSubscriptionReacivateMutation()
  //const subscriptionUpgradeMutation=useSubscriptionUpgradeMutation()
  const { data: subscriptionsPlans } = useSubscriptionsPlans();
  const [isLoading] = useIsLoading();
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod | undefined>();
  const [billingAddr, setBillingAddr] = useState<BillingAddress | undefined>();
  const activeSubscription = activesubscriptions ? activesubscriptions[0] : undefined;

  const fintechName = layout?.fintechName;
  const navigate = useNavigate();
  const [cvv, setCVV] = useState("");
  const [showDialogCVV, setShowDialogCVV] = useState(false);
  const handleBackToAppClick = useBackButton();
  const dispatch = useDispatch();
  const location = useLocation();
  const { state } = location;
  const frompage = state?.from
  
  useEffect(() => {
    AnalyticsService.track(
      "Payment Screen Viewed",
      AnalyticsAction.View,
      AnalyticsFeature.Payment,
    );
  }, []);

  
  
  const getSelectedBillingfromStore = useSelector(
    (state: SessionState) => state?.session.selectedBillingAddress
  );
  
  const getSelectedPaymentfromStore = useSelector(
    (state: SessionState) => state?.session.selectedPaymentMethod
  );

  const handleCVVChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    paymentMethodId: number
  ) => {
    const newCVV = e.target.value;
    // Ensure that CVV is not logged or displayed inappropriately
    setCVV(newCVV);
    dispatch(setNewPaymentField(newCVV)); // Only use newCVV here
    // Update CVV in Redux store
    dispatch(setPaymentCVV({ paymentMethodId, cvv: newCVV }));
  };

  const backToNavigate = useMemo(() => {
    const targetPage = session?.sessionPages?.find((page) => page.pageNumber === 81);

    const pageUrlToNavigate = targetPage?.pageUrl;
    return pageUrlToNavigate;
  }, [session]);
  const newSubscriptionPlan: SubscriptionPlanData | undefined = useMemo(() => {
    //console.log("session", session);
    const targetPage =
      session?.sessionPages?.find((page) => page.pageName === "GOALS PLANS") ||
      session?.sessionPages?.find((page) => page.pageName === "SelectedPlans");

    if (targetPage) {
      const parsedPageData = JSON.parse(targetPage.pageData.replace(/\\/g, ""));
      const pagePlanCode= parsedPageData?.subscriptionPlanCode;
     if(pagePlanCode){
        const selectedPlan = subscriptionsPlans?.find(
          (x) => x.subscriptionPlanCode === pagePlanCode
        );
        if (selectedPlan) {
          return selectedPlan;
        }
      }
      return parsedPageData;
    }

    if (activeSubscription) {
      const selectedPlan = subscriptionsPlans?.find(
        (x) => x.subscriptionPlanCode == activeSubscription?.subscriptionPlanCode
      );
      return selectedPlan;
    }
  }, [session,subscriptionsPlans,activeSubscription]);
  const { data: upgradeRate } = useRateOnUpgradePlan(
    activeSubscription?.subscriptionPlanCode,
    newSubscriptionPlan?.subscriptionPlanCode
  );

  const activePlanData = subscriptionsPlans?.find(
    (x) => x.subscriptionPlanCode === activeSubscription?.subscriptionPlanCode
  );



  const landingyespage: SessionPage | undefined = useMemo(() => {
    return session?.sessionPages?.find((page) => page.pageName === "Landingyes");
  }, [session]);
  const landingyespageData: object | undefined = useMemo(() => {
    return JSON.parse(landingyespage?.pageData?.replace(/\\/g, "") || "{}");
  }, [landingyespage]);

  const isLanding: boolean = useMemo(() => {
    const targetPage = session?.sessionPages?.find((page) => page.pageName === "Landingyes");
    const parsedPageData = JSON.parse(targetPage?.pageData?.replace(/\\/g, "") || "{}");
    return parsedPageData?.Landing;
  }, [session]);


  const subscriptionName=fintechName
  const subscriptionIcon= newSubscriptionPlan?.subscriptionIcon
  
  const isOneTime=newSubscriptionPlan?.billingCycle=== "OneTime";
  const isNotProration= newSubscriptionPlan?.isNoProrateCalculation=== true;
  const IsSubscriptionUpgrade =
    !!activePlanData 
    && activePlanData?.subscriptionPlanCode !== newSubscriptionPlan?.subscriptionPlanCode
    && !isOneTime
  
const lastSubcription= fintechSubscriptions?.find((x)=> x.subscriptionPlanCode=== newSubscriptionPlan?.subscriptionPlanCode)
const isReactivateMode= !!lastSubcription && lastSubcription.subscriptionStatus==="Canceled"


  useEffect(() => {
   if(!!paymentMethod)
   {
       if(paymentMethods && paymentMethods.find((x) => x.asaPaymentMethodCode === paymentMethod?.asaPaymentMethodCode))
       {
          //already set
          //skip this potentially active subscription came later on
          ///return;
       }
   }
    if (paymentMethods && paymentMethods?.length > 0 && session && getSelectedPaymentfromStore) {
      const matchedStore =
        paymentMethods.find((x) => x.asaPaymentMethodCode === activeSubscription?.asaPaymentMethodCode) ??
        paymentMethods.find((x) => x.paymentMethodId === getSelectedPaymentfromStore?.paymentMethodId);
      if (matchedStore) {
       
        setPaymentMethod(matchedStore);

        return;
      }
    }
    setPaymentMethod(paymentMethods?.[0]);
  }, [paymentMethods, session,  activeSubscription]);

  useEffect(() => {
    if (billingAddresses && billingAddresses?.length > 0 && getSelectedBillingfromStore) {
      const matchedStore = billingAddresses.find(
        (x) => x.consumerAddressId === getSelectedBillingfromStore?.consumerAddressId
      );
      if (matchedStore) {
        setBillingAddr(matchedStore);
        return;
      }
    }
    setBillingAddr(billingAddresses?.[0]);
  }, [billingAddresses, getSelectedBillingfromStore]);

  const handleReviewAndPayClick = () => {
    // Handle click action, such as navigating to another screen or performing some other action
    if (isLanding && !!backToNavigate) {
      navigate(backToNavigate);
    }
  };

  const onAddPaymentMethod = () => {
    navigate("/addpaymethod", { replace:true, state: { returnurl: "/subscriptionpayment" } });
  };

  const addBillingAddress = () => {
    navigate("/billingaddresses", { replace:true, state: { returnurl: "/subscriptionpayment" } });
  };

  const handlePaymentSelection = (method: PaymentMethod) => {
    //if (method.paymentType === "CC"){
    //  setCVV(paymentCVVs[method.paymentMethodId] || "");
    //}
    
    setCVV(""); // Reset CVV when changing payment method
    setPaymentMethod(method);
    dispatch(setSelectedPaymentMethod(method));
    AnalyticsService.track(
      "Payment Method Selected",
      AnalyticsAction.Click,
      AnalyticsFeature.Payment,
    );
  };

  const handleBackClick = () => {
    if (isLanding || frompage==="subscriptionmanagement") {
      navigate(-1);
      /*
      if (backToNavigate) {
        navigate(backToNavigate);
      } else {
        console.error("Page URL for page number 81 not found.");
      }
      */
    } else {
      handleBackToAppClick();
    }
  };

  const handleAddressSelection = (address: BillingAddress) => {
    // Toggle options if the same item is clicked again
    if (billingAddr !== address) {
      setBillingAddr(address); // Set the new selected address index
    }
    dispatch(setSelectedBillingAddress(address));
  };

  const handleConfirmCVV = (enteredCVV: string) => {
    setCVV(enteredCVV);
    setShowDialogCVV(false);
    handlePaymentProcess(billingAddr, paymentMethod, enteredCVV);
  };

  const handlePurchase = async () => {
    handlePaymentProcess(billingAddr, paymentMethod);
  };

  const handleUpdate = async () => {
    await handleUpdateOrReactivate(billingAddr, paymentMethod);
  };

  const handlePaymentProcess = async (
    billingfromStore: any,
    paymentfromStore: any,
    enteredCVV?: string | undefined
  ) => {
    // Check CVV only if payment type is 'cc'

    // Get the CVV corresponding to the selected payment method
    
    const cvvToUse = enteredCVV || cvv;

    if (paymentMethod?.paymentType === "CC" && !!!cvvToUse) {
      //setShowDialogCVV(true)
      showSubscriptionToast(t("pleaseEnterCvv"), true);
      return;
    }
    if (
      paymentMethod?.paymentType === "CC" &&
      (!/^\d+$/.test(cvvToUse) || !(cvvToUse.length === 3 || cvvToUse.length === 4))
    ) {
      showSubscriptionToast(t("wrongEnteredCVV"), true);
      return;
    }
    //if ( paymentfromStore?.paymentType === "CC" 
    //  && !!paymentCVVs[selectedPaymentMethodId]
    //  && enteredCVV!==paymentCVVs[selectedPaymentMethodId]){
    //  showSubscriptionToast("CVV doesn't match initial entry, please edit payment method", true);
    //  return;
    // }
    const billingAmount = IsSubscriptionUpgrade && !!upgradeRate ? upgradeRate?.proratedAmount : newSubscriptionPlan?.oneTimeAmount;

    const requestBody = {
      products: [""],
      billingDetailRequestModel: {
        billingAmount: IsSubscriptionUpgrade ? upgradeRate?.proratedAmount : billingAmount,
        comment: `Payment for Fintech ${fintechName}`,
        isRecurring: newSubscriptionPlan?.isRecurring,
        RecurringAmount: newSubscriptionPlan?.recurringAmount,
        isSubscription: true,
        consumerSignature: null,
        autoPay: true,
        recurringStartDate: null,
        billingEmail: null,
        paymentMethodId: paymentfromStore?.paymentMethodId,
        paymentMethodCode: paymentfromStore?.asaPaymentMethodCode,
        BillingCycle: newSubscriptionPlan?.billingCycle,
        isAcceptTerms: true,
        paymentType: null,
        bankAccountNumber: null,
        bankRoutingNumber: null,
        bankName: null,
        cardType: null,
        cardNumber: null,
        expiryMonth: null,
        expiryYear: null,
        firstName: null,
        middleName: null,
        lastName: null,
        CardHolderName: paymentfromStore?.paymentType === "ACH" ? null : paymentfromStore?.cardHolderName,
        CVV: paymentfromStore?.paymentType === "ACH" ? null : cvvToUse,
        subscriptionPlanCode: newSubscriptionPlan?.subscriptionPlanCode,
        address: billingfromStore?.address1,
        address2: billingfromStore?.address2,
        city: billingfromStore?.city,
        state: billingfromStore?.state,
        country: billingfromStore?.country,
        postalCode: billingfromStore?.zipCode,
        fintechApplicationCode: session?.fintechApplicationCode,
        billingAddressId: billingfromStore?.consumerAddressId,
      },
    };
    try {
      /*
      if(IsSubscriptionUpgrade)
      {
        const res = await subscriptionUpgradeMutation.mutateAsync(requestBody);
        redirectToApp(res?.message, true, 200);
      }
      else
      {
      */
      const res = await subscriptionPaymentMutation.mutateAsync(requestBody);
      AnalyticsService.track(
        "Payment Purchase Success",
        AnalyticsAction.API_Result,
        AnalyticsFeature.Payment,
        {
          subscriptionName: newSubscriptionPlan?.subscriptionTitle,
          price: billingAmount,
        },
      );
      redirectToApp(res?.message, true, 200);
      //}
    } catch (error: unknown) {
      AnalyticsService.track(
        "Payment Purchase Error",
        AnalyticsAction.API_Result,
        AnalyticsFeature.Payment,
        {
          subscriptionName: newSubscriptionPlan?.subscriptionTitle,
          price: billingAmount,
        },
      );
      if (error instanceof Error) {
        redirectToApp(error.message, false, 500);
      } else {
        redirectToApp("An unknown error occurred", false, 500);
      }
    }
  };
  const redirectToApp = (msg: string, isSuccess: boolean, status: number) => {
    if (isSuccess) {
      navigate("/paymentdone", { state: { msg: msg, status: status } });
      return;
    }
    showSubscriptionToast(msg, !isSuccess);
    const isPaymentRequired=true //layout?.isPaymentRequired
    if (isPaymentRequired) {
      return;
    }
    const targetPage = session?.sessionPages?.find((page) => page.pageNumber === 0);
    if (targetPage) {
      const pageData = JSON.parse(targetPage.pageData);

      const successDynamicLink = pageData.successDynamicLink;
      const new_url = new URL(`${successDynamicLink}`);
      new_url.searchParams.append("statusMessage", msg);
      new_url.searchParams.append("statusCode", status?.toString());

      setTimeout(() => {
        if (successDynamicLink) {
          window.location.href = new_url.toString();
        } else {
          navigate("/portfolioGoal", { state: msg });
        }
      }, 1000); // Delay for 1 second
    } else {
      navigate("/portfolioGoal", { state: msg });
    }
  };
  
  const handleUpdateOrReactivate = async (
    billingfromStore: any,
    paymentfromStore: any,
    enteredCVV?: string | undefined
  ) => {
    // Check CVV only if payment type is 'cc'

    // Get the CVV corresponding to the selected payment method

    //const billingAmount=IsSubscriptionUpgrade  && !!upgradeRate ? upgradeRate?.proratedAmount : newSubscriptionPlan?.oneTimeAmount
    // Check  exists and `inTrial` is `false`
    const cvvToUse = enteredCVV || cvv;
    
    if (paymentMethod?.paymentType === "CC" && !!!cvvToUse ) {
      //setShowDialogCVV(true)
      showSubscriptionToast(t("pleaseEnterCvv"), true);
      return;
    }
    if (
      paymentMethod?.paymentType === "CC" &&
      (!/^\d+$/.test(cvvToUse) || !(cvvToUse.length === 3 || cvvToUse.length === 4))
    ) {
      showSubscriptionToast(t("wrongEnteredCVV"), true);
      return;
    }
    if (activeSubscription?.asaPaymentMethodCode === paymentMethod?.asaPaymentMethodCode) {
      showSubscriptionToast(
        t("paymentMethodAlreadyAssociatedWithSubscription"),
        true
      );
      return;
    }
    
    const requestData = {
      paymentMethodCode: paymentMethod?.asaPaymentMethodCode,
      billingDetailCode: activeSubscription?.billingDetailCode, // Assuming this value is constant  subscriptionPlanCode: activePlanData?.subscriptionPlanCode || 15,
      address: billingfromStore?.address1,
      address2: null,
      city: billingfromStore?.city,
      state: billingfromStore?.state,
      country: billingfromStore?.country || "US",
      postalCode: billingfromStore?.zipCode,
      //billingAmount: billingAmount,
      subscriptionPlanCode: activeSubscription?.subscriptionPlanCode,
      billingAddressId: billingfromStore?.consumerAddressId,
      // in case of upgrade
      //subscriptionPlanCode: newSubscriptionPlanData?.pageData.subscriptionPlanCode 
    };
    try {
      if(isReactivateMode){
        const reactivateRequestData={
          ...requestData,
          subscriptionPlanCode: newSubscriptionPlan?.subscriptionPlanCode,
          billingDetailCode: lastSubcription?.billingDetailCode
        }
        const res = await subscriptionReacivateMutation.mutateAsync(reactivateRequestData);
        AnalyticsService.track(
          "Payment Reactivate Success",
          AnalyticsAction.API_Result,
          AnalyticsFeature.Payment,
          {
            subscriptionName: newSubscriptionPlan?.subscriptionTitle,
            price: newSubscriptionPlan?.recurringAmount,
          },
        );
        redirectToApp(res?.message, true, 200);
        return;
      }else{
        const res = await subscriptionPaymentMethodMutation.mutateAsync(requestData);
        AnalyticsService.track(
          "Payment Update Success",
          AnalyticsAction.API_Result,
          AnalyticsFeature.Payment,
          {
            subscriptionName: newSubscriptionPlan?.subscriptionTitle,
          },
        );
        redirectToApp(res?.message, true, 200);
      }
      //navigate("/portfolioGoal", { state: res?.message});
    } catch (error) {
      AnalyticsService.track(
        "Payment Update Error",
        AnalyticsAction.API_Result,
        AnalyticsFeature.Payment,
        {
          subscriptionName: newSubscriptionPlan?.subscriptionTitle,
        },
      );
      if (error instanceof Error) {
        redirectToApp(error.message, false, 500);
      } else {
        redirectToApp("An unknown error occurred", false, 500);
      }
    }
  };

  const getPeriodCharge = () => {
    if (newSubscriptionPlan) {
      if (newSubscriptionPlan?.oneTimeAmount !== newSubscriptionPlan?.recurringAmount || newSubscriptionPlan?.billingCycle==="OneTime") {
        return t("oneTime");
      }
      return newSubscriptionPlan?.billingCycle === "Annually" ? `/${t("year")}` : `/${t("month")}`;
    }
    return t("noPlanSelected");
  };

  const getDisclosureText = () => {
    // TODO: - Need to add disclosure text to ASACentral Config.
    if(newSubscriptionPlan?.disclosureMessage && newSubscriptionPlan?.disclosureTitle) {
      return {
        title: newSubscriptionPlan?.disclosureTitle,
        descr: newSubscriptionPlan?.disclosureMessage,
      };
    }
    return null;
  };
  const isTrialStart = newSubscriptionPlan?.isConsumerEligibleForTrial && newSubscriptionPlan?.freeTrialPeriod > 0;
  

  const getPaymentButtonText = (): string => {
    // If there's an active subscription
    if (!!activeSubscription) {
      // If it's not a one-time purchase
      if(isNotProration){
        return IsSubscriptionUpgrade ? t("confirmpurchase") : t("update");
      }
      else if (!isOneTime) {
        // Check if it's an upgrade scenario
        return IsSubscriptionUpgrade ? t("changePlan") : t("update");
      }
    }
    
    // For new subscriptions or one-time purchases
    if (isTrialStart) {
      return t("proceedWithTrial");
    }
    
    if (isOneTime) {
      return t("confirmpurchase");
    }
    if(isReactivateMode){
      return t("reactivatePlan");
    }
    //return t("approvePayment");
    return t("proceedWithPlan");
  };
  
  return (
    <div
      className="dark:text-white text-[#4E4E4E] relative gradient-bg-listpayments bg-gradient-to-b from-[#705AE2] to-[#490C95] flex flex-col justify-between overflow-y-scroll py-10 mx-auto space-y-5 h-screen"
      style={layout?.backGroundStyle}
    >
      {isLoading && <LoaderComponent />}
      <div className="flex items-center justify-between">
        <div className="flex items-center justify-center space-x-4">
          <img
            className="w-6 h-6 sm:w-8 sm:h-8 ml-5"
            src={arrow_back_ios_new}
            alt={t("back")}
            onClick={handleBackClick}
          />
          <p className="custom-style-bugs">{t("checkoutWithAsaPay")}</p>
        </div>
      </div>
      <div className="absolute top-24 left-0 bg-[#EBECF0] dark:bg-[#121212] right-0 bottom-0 rounded-t-3xl p-4 z-10 overflow-y-auto more-rounded">
        {/* Payment Method Dropdown */}
        <Dropdown
          title={t("selectOrAddPaymentMethod")}
          items={paymentMethods || []}
          selectedItem={paymentMethod}
          onSelect={handlePaymentSelection}
          renderItem={(method, isSelected, isSelectable) => (
            <PaymentMethodCard
              isSelectable={isSelectable}
              method={method}
              isSelected={isSelected}
              currentCVV={cvv}
              onSelect={handlePaymentSelection}
              onCVVChange={handleCVVChange}
              buttonColor={layout?.buttonColor}
            />
          )}
          addButtonLabel={t("addAnotherPaymentMethod")}
          onAddButtonClick={onAddPaymentMethod}
          isInitOpen={state?.from === "addpaymethod" && !!!state?.isUpdate}
          buttonColor={layout?.buttonColor}
        />

        <div className="border-t border-[#D9D9D9] dark:border-white/20 mx-2.5 mt-2.5"></div>

        {paymentMethod && paymentMethod?.paymentType === "CC" && (
          <>
            {/* Billing Address Dropdown */}
            <Dropdown
              title={t("selectOrAddBillingAddress")}
              items={billingAddresses || []}
              selectedItem={billingAddr}
              onSelect={handleAddressSelection}
              renderItem={(address, isSelected, isSelectable) => (
                <BillingAddressCard
                  isSelectable={isSelectable}
                  address={address}
                  isSelected={isSelected}
                  onSelect={handleAddressSelection}
                  buttonColor={layout?.buttonColor}
                />
              )}
              addButtonLabel={t("addBillingAddress")}
              onAddButtonClick={addBillingAddress}
              isInitOpen={state?.from === "billingaddresses" && !!!state?.isUpdate}
              buttonColor={layout?.buttonColor}
            />
            <div className="border-t border-[#D9D9D9] dark:border-white/20 mx-2.5 mt-2.5"></div>
          </>
        )}
        {showDialogCVV && (
          <ConfirmDialogCVV
            title={t("addCvv")}
            message={t("pleaseEnterCvv")}
            onCancel={() => setShowDialogCVV(false)}
            onConfirm={handleConfirmCVV}
            isOpen={showDialogCVV}
          />
        )}

        {newSubscriptionPlan &&
                  (
                    (paymentMethod?.paymentType === "CC" && !!paymentMethod  && !!billingAddr ) 
                    ||
                    (paymentMethod?.paymentType === "ACH" && !!paymentMethod )
                  ) 
                    && 
        (
          <div className="mt-6 mb-20">
            <h2 className=" text-[20px] leading-6 mb-4 font-poppins font-bold ml-2">
              {t("reviewAndPay")}
            </h2>
            <div className="flex items-center justify-between rounded-lg">
              <div className="w-16 h-16 p-2 rounded-12">
                <img
                  onClick={isLanding ? handleReviewAndPayClick : () => {}}
                  className="w-full h-full cursor-pointer"
                  src={subscriptionIcon ?? ""}
                  alt="Subscription Icon"
                />
              </div>

              <div className="flex-1 text-left ml-2">
                <p
                  className="review-name-p"
                  onClick={isLanding ? handleReviewAndPayClick : () => {}} // Use a no-op function if not clickable                    className="text-[#FFFFFF] font-semibold font-poppins text-[14px] leading-4 text-left"
                >
                  {subscriptionName}
                </p>

                <p
                  onClick={isLanding ? handleReviewAndPayClick : () => {}} // Use a no-op function if not clickable                    className="text-[#FFFFFF] font-semibold font-poppins text-[14px] leading-4 text-left"
                  className="eview-pay-fintech  font-poppins text-[12px] font-medium leading-4 mt-1"
                >
                  {newSubscriptionPlan?.subscriptionTitle}
                </p>
              </div>
              <div className="text-right">
                {newSubscriptionPlan && isTrialStart === false && activePlanData && newSubscriptionPlan ? (
                  <>
                    <p className=" font-poppins font-semibold text-[14px]">
                      $
                      {(newSubscriptionPlan?.isRecurring?
                      newSubscriptionPlan?.recurringAmount : newSubscriptionPlan?.oneTimeAmount)
                      || 'N/A' }

                    </p>
                    <p className=" leading-6 text-[12px] font-poppins">
                      {newSubscriptionPlan?.billingCycle === "Annually"
                        ? t("year")
                        : t("month")}
                    </p>
                  </>
                ) : (
                  <div className="text-right">
                    <p className="review-recurring-amount font-poppins font-semibold text-[14px]">
                      ${newSubscriptionPlan?.oneTimeAmount}
                    </p>
                    <p className="subscription-type  leading-6 text-[12px] font-poppins">
                      {getPeriodCharge()}
                    </p>
                  </div>
                )}
              </div>
            </div>
            {IsSubscriptionUpgrade && !isNotProration && (
              <>
                <div className="flex items-center justify-between rounded-lg">
                  <div className="w-16 h-16 p-2 rounded-12">
                    <img
                      onClick={isLanding ? handleReviewAndPayClick : () => {}}
                      className="w-full h-full cursor-pointer"
                      src={activePlanData?.subscriptionIcon ?? ""}
                      alt="Subscription Icon"
                    />
                  </div>
                  <div className="flex-1 text-left ml-2">
                    <p
                      className="review-name-p"
                      onClick={isLanding ? handleReviewAndPayClick : () => {}} // Use a no-op function if not clickable                    className="text-[#FFFFFF] font-semibold font-poppins text-[14px] leading-4 text-left"
                    >
                      {fintechName}
                    </p>

                    <p
                      onClick={isLanding ? handleReviewAndPayClick : () => {}} // Use a no-op function if not clickable                    className="text-[#FFFFFF] font-semibold font-poppins text-[14px] leading-4 text-left"
                      className="eview-pay-fintech font-poppins text-[12px] font-medium leading-4 mt-1"
                    >
                      {activePlanData?.subscriptionTitle}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-[#00D22D] font-poppins font-semibold text-[14px]">
                      ${activePlanData.isRecurring ? activePlanData?.recurringAmount : activePlanData?.oneTimeAmount}
                    </p>
                    <p className=" leading-6 text-[12px] font-poppins">{t("currentPlan")}</p>
                  </div>
                </div>
                <div className="flex  justify-content-end rounded-lg">
                  <div className="text-right w-full">
                    <p className=" font-poppins font-semibold text-[14px]">
                      ${upgradeRate?.proratedAmount}
                    </p>
                    <p className=" leading-6 text-[12px] font-poppins">{t("dueToday")}</p>
                  </div>
                </div>
              </>
            )}

            {/* Approve Payment Button */}

            {getDisclosureText() !== null ? (
              <div className="rounded-xl mt-4 p-4 dark:bg-[#2C2C2C] bg-[#D9D9D9] ">
                <div className="font-poppins text-center text-xs/5 font-bold">
                  {getDisclosureText()?.title}
                </div>
                <div className="font-poppins text-center text-xs/5 font-medium opacity-70">
                  {getDisclosureText()?.descr}
                </div>
              </div>
            ) : null}
            <div className="fixed bottom-0 left-0 right-0 p-4">
              <button
                onClick={() => {
                  if (!!activeSubscription && IsSubscriptionUpgrade) {
                    handlePurchase();
                  } else if (!!activeSubscription && !isOneTime) {
                    handleUpdate();
                  } else if(isReactivateMode){
                    handleUpdate();
                  } else {
                    handlePurchase();
                  }
                }}
                className="w-full bg-[#705AE2] text-white py-4 rounded-lg mt-6 transition duration-300 focus:outline-none focus:ring-2 font-poppins font-bold shadow-md"
                style={layout?.buttonStyle}
                id="payment-button"
              >
                {getPaymentButtonText()}
              </button>
            </div>
          </div>
        )}
        {/* Debugging Information */}
      </div>
    </div>
  );
};

export default SubscriptionPayment;
